module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-profile"
  }, [_vm._m(0), _c('div', {
    staticClass: "client-drivers tabs-inner-content"
  }, [_c('div', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "is-hidden",
    attrs: {
      "id": "edit-main-driver",
      "data-toggler": "is-hidden"
    }
  }, [(_vm.options) ? _c('selectize-driver', {
    attrs: {
      "clientDrivers": _vm.options
    },
    on: {
      "optionSelected": _vm.driverSelected
    }
  }) : _vm._e(), _c('button', {
    staticClass: "button success",
    on: {
      "click": _vm.updateMainDriver
    }
  }, [_vm._v("Update Main driver")])], 1)]), _c('div', {
    staticClass: "tabs-inner-content"
  }, [_c('div', {
    staticClass: "client-profile"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('client', {
    attrs: {
      "type": 'personal-data',
      "item": _vm.client
    }
  }), _c('client', {
    attrs: {
      "type": 'billing',
      "item": _vm.client
    }
  })], 1), _c('div', {
    staticClass: "columns"
  }, [_c('client', {
    attrs: {
      "type": 'contacts',
      "item": _vm.client
    }
  }), _c('client', {
    attrs: {
      "type": 'main-driver',
      "item": _vm.client
    }
  }), _c('div', {
    staticClass: "columns driver-licenses"
  }, _vm._l((_vm.driverLicenses), function(license) {
    return _c('driver-licence', {
      attrs: {
        "type": 'license-card-accordion',
        "item": license
      }
    })
  }), 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Client Profile")])]), _c('div', {
    staticClass: "action"
  }, [_c('span', {
    attrs: {
      "data-toggle": "edit-main-driver"
    }
  }, [_vm._v("Edit main driver")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28b11ddc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientProfile.vue
// module id = 2353
// module chunks = 1